import React from 'react';
import CapRow from '../CapRow';
import './_index.scss';
import L1ModuleWrapper from './L1ModuleWrapper';
import { L1IconWrapperSize } from './constants';
const ProductModules = ({
  currentState,
  dispatchAction,
  handleRedirectionAndModuleSelection,
  redirectToLink,
  pushDataToGTM,
  leftNavbarExpanded
}) => {
  const filteredConfig = currentState.sortedConfig?.filter(
    x => x.placement !== 'bottom',
  );
  const l1Height =
    (currentState.sortedConfig.length - filteredConfig.length) *
    L1IconWrapperSize;
  return (
    <CapRow
      className="l1-product-row"
      style={{
        height: `calc(100vh - ${l1Height + 18}px)`,
      }}
    >
      {filteredConfig?.map(
        (module, index) =>
          module?.isVisible &&
          module?.isActive && (
            <L1ModuleWrapper
              moduleObj={module}
              index={index}
              key={`ProductMode_${module?.name}`}
              currentState={currentState}
              dispatchAction={dispatchAction}
              handleRedirectionAndModuleSelection={
                handleRedirectionAndModuleSelection
              }
              redirectToLink={redirectToLink}
              pushDataToGTM={pushDataToGTM}
              leftNavbarExpanded={leftNavbarExpanded}
            />
          ),
      )}
    </CapRow>
  );
};

ProductModules.defaultProps = {
  currentState: {},
  dispatchAction: () => {},
  handleRedirectionAndModuleSelection: () => {},
  redirectToLink: () => {},
  pushDataToGTM: () => {},
};

export default ProductModules;
